module.exports = "img/flags/MC.396cd4a.png";